export * from "./active";
export * from "./countries";
export * from "./segments";
export * from "./dates";
export * from "./day";
export * from "./game";
export * from "./layers";
export * from "./storylines";
export * from "./wrestlers";
export * from "./groups";
export * from "./tiers";
export * from "./dialog";
export * from "./spacing";
export * from "./palette";
export * from "./venues";
export var fontFamilies = {
    primaryFont: "'Archivo Black'",
    secondaryFont: "'Archivo'",
    bodyFont: "'Archivo'",
    buttonFont: "'Archivo'"
};
export var defaultSegmentDuration = 60 * 5;
export var BORDERRADIUS = "5px";
export var DURATIONTIMEOUT = 1200;
